import { QButton, QEmptyState, QEmptyStateButtonGroup, QEmptyStatePrimaryButton } from '@qualio/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { TemplateDetail } from '../../types';
import { useTemplateActions } from '../../hooks/useTemplateActions';

type NoSectionsPanelProps = {
  template: TemplateDetail;
};

export const NoSectionsPanel: React.FC<NoSectionsPanelProps> = ({ template }) => {
  const { t } = useTranslation();
  const { canAddSections } = useTemplateActions(template);
  const [, setSearchParams] = useSearchParams();

  const handleEdit = () => setSearchParams({ intent: 'edit' });

  return (
    <QEmptyState title={t('template.sections.noSections.title')}>
      {canAddSections && (
        <QEmptyStateButtonGroup>
          <QEmptyStatePrimaryButton>
            <QButton variant="outline" leftIcon="Plus" onClick={handleEdit} data-cy="add-sections-button">
              {t('template.sections.noSections.buttonLabel')}
            </QButton>
          </QEmptyStatePrimaryButton>
        </QEmptyStateButtonGroup>
      )}
    </QEmptyState>
  );
};
